export const LIST_EXTRA_QUOTA = 'LIST_EXTRA_QUOTA';
export const SAVED_EXTRA_QUOTUM = 'SAVED_EXTRA_QUOTUM';
